// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_folder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/uploadAlt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/708-search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__children___rNrey {
  background-color: blue;
}

.styles__drag___b5kit {
  border: 2px dashed gtGreen;
  background: #E2F1EE;
}

.styles__dropzoneArea___X28KP {
  width: 100%;
}

.styles__fileFolderIcon___Re0LJ {
  float: left;
  height: 25px;
  width: 55px;
}

.styles__fileNameInput___giTTn {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  width: 80%;
}

.styles__fileUploadButton___jkcwq {
  width: 18%;
}

.styles__folderIcon___ZIEpZ {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left;
}

.styles__folderCell___D8biv .styles__childLink___eJJTM {
  float: right;
}

.styles__hidden___slw9I {
  visibility: hidden;
}

.styles__lowerUploadControls___b1ILZ {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  height: 30px;
}

::-webkit-input-placeholder {
  opacity: 0.7;
}

.styles__previewLink___MpBmy img {
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  border-width: 0;
}

.styles__upIcon___ygW8A {
  display: inline-block;
  vertical-align: middle;
  pointer-events: none;
  height: 80px;
  width: 50px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat left center;
  background-size: 32px;
}

.styles__uploadControls___YJv24 {
  width: 100%;
}

.styles__uploadText___03huD {
  pointer-events: none;
  display: inline-block;
  height: 80px;
}

/* Files table columns */

.styles__download___uqoEq {
  cursor: pointer;
}

.styles__preview___hTjmV {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__preview___hTjmV a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__remove___ZEEx3 {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__remove___ZEEx3 a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

/* Delete modal */

.styles__section___gWY7L {
}

.styles__buttons___Fvc2z {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.styles__spacer___H0dxT {
  display: inline-block;
  width: 1em;
}

.styles__removeBtn___zxs0x {
}

.styles__cancelBtn___Mhlb2 {
}
`, "",{"version":3,"sources":["webpack://./universal/components/FileFolders/styles.css"],"names":[],"mappings":"AAIA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8DAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,kEAA4D;AAC9D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAgC;EAAhC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,yEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;AACd;;AAEA,wBAAwB;;AAExB;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAkD;EAClD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF,iBAAiB;;AAEjB;AAEA;;AAEA;EACE,mBAAmB;EAEnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: 'styles/colors.css';\n@value gtGray, gtRed, textLight from colors;\n\n.children {\n  background-color: blue;\n}\n\n.drag {\n  border: 2px dashed gtGreen;\n  background: #E2F1EE;\n}\n\n.dropzoneArea {\n  composes: dropzoneArea from helpers;\n  width: 100%;\n}\n\n.fileFolderIcon {\n  float: left;\n  height: 25px;\n  width: 55px;\n}\n\n.fileNameInput {\n  border: 1px solid gtGray;\n  width: 80%;\n}\n\n.fileUploadButton {\n  width: 18%;\n}\n\n.folderIcon {\n  composes: fileFolderIcon;\n  background: url('styles/img/icon_folder.png') no-repeat left;\n}\n\n.folderCell .childLink {\n  float: right;\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.lowerUploadControls {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n  height: 30px;\n}\n\n::-webkit-input-placeholder {\n  opacity: 0.7;\n}\n\n.previewLink img {\n  text-decoration: none !important;\n  border-width: 0;\n}\n\n.upIcon {\n  display: inline-block;\n  vertical-align: middle;\n  pointer-events: none;\n  height: 80px;\n  width: 50px;\n  background: url(\"styles/img/uploadAlt.png\") no-repeat left center;\n  background-size: 32px;\n}\n\n.uploadControls {\n  width: 100%;\n}\n\n.uploadText {\n  pointer-events: none;\n  display: inline-block;\n  height: 80px;\n}\n\n/* Files table columns */\n\n.download {\n  cursor: pointer;\n}\n\n.preview {\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/708-search.png\");\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.remove {\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/icon_close--gray.png\");\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n/* Delete modal */\n\n.section {\n  composes: section from helpers;\n}\n\n.buttons {\n  align-items: center;\n  composes: section from helpers;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.spacer {\n  display: inline-block;\n  width: 1em;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `'styles/colors.css'`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"children": `styles__children___rNrey`,
	"drag": `styles__drag___b5kit`,
	"dropzoneArea": `styles__dropzoneArea___X28KP ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropzoneArea"]}`,
	"fileFolderIcon": `styles__fileFolderIcon___Re0LJ`,
	"fileNameInput": `styles__fileNameInput___giTTn`,
	"fileUploadButton": `styles__fileUploadButton___jkcwq`,
	"folderIcon": `styles__folderIcon___ZIEpZ styles__fileFolderIcon___Re0LJ`,
	"folderCell": `styles__folderCell___D8biv`,
	"childLink": `styles__childLink___eJJTM`,
	"hidden": `styles__hidden___slw9I`,
	"lowerUploadControls": `styles__lowerUploadControls___b1ILZ`,
	"previewLink": `styles__previewLink___MpBmy`,
	"upIcon": `styles__upIcon___ygW8A`,
	"uploadControls": `styles__uploadControls___YJv24`,
	"uploadText": `styles__uploadText___03huD`,
	"download": `styles__download___uqoEq`,
	"preview": `styles__preview___hTjmV`,
	"remove": `styles__remove___ZEEx3`,
	"section": `styles__section___gWY7L ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"buttons": `styles__buttons___Fvc2z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"spacer": `styles__spacer___H0dxT`,
	"removeBtn": `styles__removeBtn___zxs0x ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___Mhlb2 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`
};
export default ___CSS_LOADER_EXPORT___;
